/**
 * Origem Flow: modelos prontos de documento do hub de Docs. O conteúdo é
 * markdown — o editor transforma em texto rico ao abrir.
 */

export const DOC_TEMPLATES = [
  {
    key: 'meetingNotes',
    icon: 'iconoir-community',
    name: 'Ata de reunião',
    content: `# Ata de reunião — [assunto]

**Data:** [dd/mm/aaaa] · **Participantes:** [nomes]

## Pauta

- [tópico 1]
- [tópico 2]

## Discussão e decisões

- **[tópico 1]:** [o que foi discutido e decidido]
- **[tópico 2]:** [o que foi discutido e decidido]

## Encaminhamentos

- [ ] [ação] — responsável: [nome], prazo: [data]
- [ ] [ação] — responsável: [nome], prazo: [data]

## Próxima reunião

[data e pauta prevista]`,
  },
  {
    key: 'clientBriefing',
    icon: 'iconoir-user',
    name: 'Briefing de cliente',
    content: `# Briefing — [cliente]

## Sobre o cliente

- **Empresa:** [nome]
- **Segmento:** [segmento]
- **Contato principal:** [nome, cargo, e-mail/telefone]
- **Site / redes:** [links]

## Contexto e desafio

[Qual o momento do cliente e que problema precisamos resolver?]

## Objetivos

1. [objetivo principal]
2. [objetivo secundário]

## Público-alvo

[Quem queremos atingir?]

## Escopo e entregáveis

- [entregável 1]
- [entregável 2]

## Prazos e orçamento

- **Início:** [data] · **Entrega:** [data]
- **Orçamento:** [valor]

## Observações

[restrições, referências, o que evitar]`,
  },
  {
    key: 'proposal',
    icon: 'iconoir-doc-star',
    name: 'Proposta comercial',
    content: `# Proposta comercial — [cliente]

**Data:** [dd/mm/aaaa] · **Validade:** [30 dias]

## Entendimento da necessidade

[Resumo do desafio do cliente com as palavras dele.]

## Solução proposta

[O que vamos fazer e por quê.]

## Escopo

- [item 1]
- [item 2]
- [item 3]

> Fora do escopo: [o que NÃO está incluído]

## Cronograma

1. **Semana 1–2:** [etapa]
2. **Semana 3–4:** [etapa]

## Investimento

| Item | Valor |
| --- | --- |
| [serviço 1] | R$ [valor] |
| [serviço 2] | R$ [valor] |
| **Total** | **R$ [valor]** |

## Condições

- [forma de pagamento]
- [o que o cliente precisa fornecer]`,
  },
  {
    key: 'actionPlan',
    icon: 'iconoir-task-list',
    name: 'Plano de ação',
    content: `# Plano de ação — [objetivo]

**Meta:** [o que queremos alcançar] · **Prazo:** [data]

## Situação atual

[Onde estamos hoje e por que agir.]

## Ações

- [ ] **[ação 1]** — responsável: [nome], prazo: [data]
- [ ] **[ação 2]** — responsável: [nome], prazo: [data]
- [ ] **[ação 3]** — responsável: [nome], prazo: [data]

## Riscos e dependências

- [risco 1 e como mitigar]

## Como vamos medir

- [indicador 1: meta]
- [indicador 2: meta]

## Acompanhamento

[Frequência e formato do acompanhamento: reunião semanal, relatório, etc.]`,
  },
  {
    key: 'weeklyReport',
    icon: 'iconoir-calendar',
    name: 'Relatório semanal',
    content: `# Relatório semanal — [cliente/projeto]

**Semana:** [dd/mm] a [dd/mm]

## Resumo da semana

[2–3 frases sobre o andamento geral.]

## O que foi feito

- [entrega 1]
- [entrega 2]

## Em andamento

- [item] — [status e previsão]

## Bloqueios e pendências

- [o que está travado e o que precisamos]

## Próxima semana

- [prioridade 1]
- [prioridade 2]`,
  },
]
